import React from 'react';
import AllAssignmentItem from '../../../../../Domain/AllAssignmentItem';
import TabOfDataTable from '../../../../../Elements/DataTable/TabOfDataTable';
import ProjectAssignmentService from '../../../../../Services/ProjectAssignmentsService';
import AssignmentSearchParams from '../AssignmentSearchParams';
import AssignmentsListBase from './AssignmentsListBase';

export default class AllAssignmentsList extends AssignmentsListBase {
  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    return ProjectAssignmentService.GetAssignmentList(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      this.getSearchParameters(searchItem),
      clearCache
    );
  }

  getTabOfDataTable() {
    return (
      <TabOfDataTable
        type={AllAssignmentItem}
        shownPanel={this.state.shownPanel}
        serviceFunction={this.serviceFunction.bind(this)}
        convertDBItemsFunction={ProjectAssignmentService.ConvertAllDBItems}
        searchItem={this.state.searchItem}
        searchParamsType={AssignmentSearchParams}
        orderDirection={this.state.orderDirection}
        showSearchStrip={true}
        clickOnStartSearch={this.startSearch}
        itemList={this.state.itemList}
        changeOfItemListFunction={this.changeOfItemListFunction.bind(this)}
        enableUrlPush={false}
        errorCode='AAL41'
        singleSearchLine={true}
        singleSearchLinePlaceholder='Search in Apollo/Location ID and country code...'
        forceClearCacheOnSearch={true}
      />
    );
  }

  renderSelectAllLink() {
    return null;
  }
}
